import { CancelOrderRequestSchema, CancelOrderResponseSchema, ConfirmOrderRequestSchema, ConfirmOrderResponseSchema, CreateOrderRequestSchema, OrderCreateResponseSchema, OrderDetailResponseSchema, OrderDevicesResponseSchema, OrderInventoryAvailabilityResponseSchema, OrderListQuerySchema, OrderListResponseSchema, OrderReferenceParamSchema, OrdersForTenantQuerySchema, OrderUpdateResponseSchema, ProviderClaimOrderOnBehalfRequestSchema, ProviderClaimOrderOnBehalfResponseSchema, ShipOrderRequestSchema, ShipOrderResponseSchema, UpdateOrderRequestSchema, } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/provider/ops-orders.routes.ts`. */
export const providerOrdersContract = {
    list: {
        method: 'GET',
        path: '/provider/orders',
        query: OrderListQuerySchema,
        response: OrderListResponseSchema,
        responseStyle: 'parse-response',
        queryLimitMax: 100,
        errorMessage: 'Failed to list orders',
    },
    listForTenant: {
        method: 'GET',
        path: '/provider/orders/for-tenant',
        query: OrdersForTenantQuerySchema,
        response: OrderListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list orders for tenant',
    },
    create: {
        method: 'POST',
        path: '/provider/orders',
        body: CreateOrderRequestSchema,
        response: OrderCreateResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to create order',
    },
    getByReference: {
        method: 'GET',
        path: '/provider/orders/:orderReference',
        pathParams: OrderReferenceParamSchema,
        response: OrderDetailResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get order',
    },
    update: {
        method: 'PUT',
        path: '/provider/orders/:orderReference',
        pathParams: OrderReferenceParamSchema,
        body: UpdateOrderRequestSchema,
        response: OrderUpdateResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update order',
    },
    getDevices: {
        method: 'GET',
        path: '/provider/orders/:orderReference/devices',
        pathParams: OrderReferenceParamSchema,
        response: OrderDevicesResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get order devices',
    },
    getInventoryAvailability: {
        method: 'GET',
        path: '/provider/orders/:orderReference/inventory-availability',
        pathParams: OrderReferenceParamSchema,
        response: OrderInventoryAvailabilityResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get order inventory availability',
    },
    confirm: {
        method: 'POST',
        path: '/provider/orders/:orderReference/confirm',
        pathParams: OrderReferenceParamSchema,
        body: ConfirmOrderRequestSchema,
        response: ConfirmOrderResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to confirm order',
    },
    cancel: {
        method: 'POST',
        path: '/provider/orders/:orderReference/cancel',
        pathParams: OrderReferenceParamSchema,
        body: CancelOrderRequestSchema,
        response: CancelOrderResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to cancel order',
    },
    ship: {
        method: 'POST',
        path: '/provider/orders/:orderReference/ship',
        pathParams: OrderReferenceParamSchema,
        body: ShipOrderRequestSchema,
        response: ShipOrderResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to ship order',
    },
    claimOnBehalf: {
        method: 'POST',
        path: '/provider/orders/:orderReference/claim-on-behalf',
        pathParams: OrderReferenceParamSchema,
        body: ProviderClaimOrderOnBehalfRequestSchema,
        response: ProviderClaimOrderOnBehalfResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to claim order on behalf of tenant',
    },
};
//# sourceMappingURL=provider-orders.contract.js.map